import React from 'react';
import ReactI18n from 'react-i18n';
import { IconFontAwesome } from '@directsoftware/ui-kit-web-admin';
import Link from '../links/link';

const GuestNav = ({ activeTab, bookingCode, slug }) => {
  const translate = ReactI18n.getIntlMessage;

  if (!bookingCode) return null;

  const withSlug = path =>
    slug
      ? `/my-bookings/${path}/${slug}/${bookingCode}`
      : `/my-bookings/${path}/${bookingCode}`;

  const tabs = [
    {
      key: 'stay',
      to: withSlug('receipt'),
      icon: 'house',
      label: translate(`cx.guest_nav.stay`)
    },
    {
      key: 'payments',
      to: `/my-bookings/payment/${bookingCode}`,
      icon: 'creditCard',
      label: translate(`cx.guest_nav.payments`)
    },
    {
      key: 'verification',
      to: withSlug('verification'),
      icon: 'listCheck',
      label: translate(`cx.guest_nav.verification`)
    }
  ];

  return (
    <nav className="guestNav" aria-label={translate(`cx.guest_nav.aria_label`)}>
      {tabs.map(tab => (
        <Link
          key={tab.key}
          to={tab.to}
          className={`guestNav__item${
            activeTab === tab.key ? ' guestNav__item--active' : ''
          }`}
          aria-current={activeTab === tab.key ? 'page' : undefined}
        >
          <IconFontAwesome name={tab.icon} />
          <span className="guestNav__label">{tab.label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default GuestNav;
